import { useQuery } from 'react-query';
import { API_ENDPOINTS } from '../../../rest/utils/api-endpoints';
import { HttpClient } from '../../../rest/utils/http';
import { IPendingYear } from '../types/renewalTypes';
import { IApiResponse } from '../../../rest/types';

export function usePendingYearDataQuery() {
  return useQuery<IApiResponse<IPendingYear>, Error>(
    [API_ENDPOINTS.GET_RENEWAL_PENDING_YEAR],
    () =>
      HttpClient.get<IApiResponse<IPendingYear>>(
        API_ENDPOINTS.GET_RENEWAL_PENDING_YEAR
      ),
    {
      refetchOnWindowFocus: false,
    }
  );
}
